/*
 * @Description: mark
 * @Author: wangwangwang
 * @Date: 2020-09-11 09:14:16
 * @LastEditors  : yangxr
 * @LastEditTime : 2022-07-19 14:05:49
 */
import request from "@/utils/request";
export const queryPage = "/icps/system/sign/dataCollection/lotMaintain/QueryPage";
export const batchUpdateOrDelete = "/icps/system/sign/basics/rawMaterials/deletes";
export const saveOrUpdate = "/icps/system/sign/dataCollection/lotMaintain/saveOrUpdate";
export const Download = "/icps/system/sign/basics/rawMaterials/exportList";
/*删除份额 */
export function updateLoMaintain(data) {
  return request({
    url: "/icps/system/sign/dataCollection/lotMaintain/updateLoMaintain",
    method: "post",
    data,
  });
}
/*获取合同签订主体 */
export function getSupplierCooperationList(params) {
  return request({
    url: "/icps/system/sign/dataCollection/lotMaintain/getSupplierCooperationList",
    method: "get",
    params,
  });
}
/*获取合同签订主体 */
export function getSubjectListByLot(data) {
  return request({
    url: "/icps/system/sign/dataCollection/lotMaintain/getSubjectListByLot",
    method: "post",
    data,
  });
}
/*获取份额量列表*/
export function getLotAllots(data) {
  return request({
    url: "/icps/system/sign/dataCollection/lotMaintain/getLotAllots",
    method: "post",
    data,
  });
}
/*获取审批记录*/
export function getauditLot(data) {
  return request({
    url: "/icps/system/sign/dataCollection/lotMaintain/getAuditLots",
    method: "post",
    data,
  });
}
/*获取合同列表*/
export function getContracts(data) {
  return request({
    url: "/icps/system/sign/dataCollection/contract/getContracts",
    method: "post",
    data,
  });
}
/*获取合同列表*/
export function saveOrUpdate2(data) {
  return request({
    url: "/icps/system/sign/dataCollection/lotMaintain/saveOrUpdate",
    method: "post",
    data,
  });
}
/*获取合同列表*/
export function uodateStatus(data) {
  return request({
    url: "/icps/system/sign/dataCollection/lotMaintain/uodateStatus",
    method: "post",
    data,
  });
}

/*获取强度等级及规范性能*/
export function getContractList(data) {
  return request({
    url: "/icps/system/sign/basics/qualityDetection/getContractList",
    method: "post",
    data,
  });
}
/*根据站点获取份额列表 */
export function getShare(data) {
  return request({
    url: "/icps/system/sign/dataCollection/lotMaintain/QueryPage",
    method: "post",
    data,
  });
}
